import React, { useState, useEffect } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomRequiredInputLabel,
} from "../../common/StyledComponents/StyledFields";
import { apiRequest } from "../../../infrastructure/backendService";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";
import { Box, Grid } from "@mui/material";

const formFieldsPoojaBookingReport = {
  specialEvents: "",
};

const EventRegistrations = ({ sendDataToParent, getReportData }: any) => {
  const [formData, setFormData] = useState(formFieldsPoojaBookingReport);
  const [loading, setLoading] = useState<boolean>(false);
  const [events, setEvents] = useState<any>([{}]);

  useEffect(() => {
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/treasury/VOLUNTEER_REPORT/eventList",
      includeToken: true,
    })
      .then((res) => {
        setEvents(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formData.specialEvents]);

  const getVolunteerReport = () => {
    const reqBody = {
      ...(formData.specialEvents && { eventId: formData.specialEvents }),
      pagination: true,
      pageNumber: 0,
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/treasury/VOLUNTEER_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, {
          reqBody,
          totalElements: res.data.totalElements,
          pageSize: res.data.pagesize,
          totalNumberofHours: res.data.totalDonatedAmount,
        });
        const response = res.data.data.map((report: any) => {
          return {
            "Sign-in name": report.name,
            Event: report.event,
            Description: report.description,
            Date: report.date,
            "Start Time": report.starttime,
            "No of Hours worked": report.totalhours,
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitBookReport = async () => {
    try {
      getVolunteerReport();
    } catch (error) {}
  };

  const handleFieldChange = (field: any, value: any) => {
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const SpecialEventsDropDown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="grouped-select"
        handleDropdownChange={handleFieldChange}
        errorMessage={""}
        dropDownList={events}
        value={formData.specialEvents}
        fieldName="specialEvents"
        placeholder={""}
        optionLabel="name"
        optionValue="eventid"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };

  const handleClear = () => {
    setFormData({ ...formFieldsPoojaBookingReport });
  };

  return (
    <Box sx={{ maxWidth: "450px" }}>
      <Grid container rowSpacing={"10px"} sx={{ marginTop: "0px" }}>
        <Grid
          container
          columnSpacing={"12px"}
          rowSpacing={"10px"}
          sx={{ marginTop: "0px" }}
        >
          <Grid item xs={12} sm={6}>
            {CustomRequiredInputLabel("Special Events", false)}
            {SpecialEventsDropDown()}
          </Grid>
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitBookReport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </Box>
  );
};
export default EventRegistrations;
